import PageWrapper from "../../../components/Page/PageWrapper";
import PageTitle from "../../../components/Page/PageTitle";
import DailyForOverlimitFilters from "./components/DailyForOverlimitFilters";
import DailyForOverlimitTable from "./components/DailyForOverlimitTable";
import { useTranslation } from "react-i18next";

function DailyForOverlimit() {
  const { t } = useTranslation();

  return (
    <PageWrapper>
      <PageTitle title={t("pageHeaders.dailyOverlimitReports")} />
      <DailyForOverlimitFilters />
      <DailyForOverlimitTable />
    </PageWrapper>
  );
}

export default DailyForOverlimit;
